import { Alert, Button, Checkbox, Col, Form, Input, Modal, notification, Row } from 'antd'
import axios from 'axios'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useContext, useEffect, useState, useRef } from 'react'
import { SignLayout } from 'src/components/Layout/SignLayout'
import { SEO } from 'src/components/SEO'
import * as api from 'src/configs/API'
import BASE_CONFIG from 'src/configs/base'
import { GlobalContext } from '../_app'
import { useForm } from 'antd/lib/form/Form'
import ReCAPTCHA from 'react-google-recaptcha'
import NotifyPopup from 'src/components/NotifyPopup'
import PasswordForm from 'src/components/UserOptions/PasswordForm'
import VerifyLoginModal from 'src/components/Profile/VerifyLoginModal'

const Login = () => {
	const { getUser, user } = useContext(GlobalContext)
	const recaptchaRef = useRef(null)
	const recaptchaActiveRef = useRef(null)

	const router = useRouter()
	const [form] = Form.useForm()
	const [formActive] = Form.useForm()
	const [showAlert, setShowAlert] = useState(false)
	const [loading, setLoading] = useState(false)
	const [messageError, setMessageError] = useState('')
	const [token, setToken] = useState('')
	const [tokenRecaptcha, setTokenRecaptcha] = useState('')
	const [tokenRecaptchaActive, setTokenRecaptchaActive] = useState('')
	const [isLogin, setIsLogin] = useState(true)
	//Modal Active Account
	const [message, setMessage] = useState('')
	const [srcImg, setSrcImg] = useState('/images/success_noti.png')
	const [isOpen, setIsOpen] = useState(false)
	//UserName khi tk chưa kích hoạt web
	const [userName, setUserName] = useState('')
	const [isOpenOTP, setIsOpenOTP] = useState(false)

	// check message and tFAMethod
	const [messageTFA, setMessageTFA] = useState('')
	const [tFAMethod, setTFAMethod] = useState('')
	useEffect(() => {
		if (router.query.isLogin !== undefined) {
			setUserName(router.query.userName)
			setIsLogin(router.query.isLogin === 'false' ? false : true)
		}
	}, [])
	const onLogin = () => {
		if (typeof window !== 'undefined') {
			if (!window.location.hostname.includes('localhost')) {
				if (!tokenRecaptcha) {
					recaptchaRef.current?.reset?.()
					setTokenRecaptcha('')
					notification.error({
						message: 'Hệ thống',
						description: 'Vui lòng xác thực mã captcha',
					})
					return
				}
			}
		}

		form.validateFields().then((values) => {
			setLoading(true)
			if (!tokenRecaptcha) {
				recaptchaRef.current?.reset?.()
				setTokenRecaptcha('')
				notification.error({
					message: 'Hệ thống',
					description: 'Vui lòng xác thực mã captcha',
				});
				setLoading(false)
				return
			}
			axios
				.post(api.PMS_ENDPOINT + api.default.API_CLIENT_LOGIN, values, {
					headers: {
						'Content-Type': 'application/json',
						TokenRecaptcha: tokenRecaptcha,
					}
				})
				.then((res) => {

					if (res.data.isError) {
						recaptchaRef.current?.reset?.()
						setTokenRecaptcha('')
						setShowAlert(true)
						setMessageError(res.data.errorMessage)
						setLoading(false)
					} else {
						getUser(res.data)
						window.localStorage.setItem('user', JSON.stringify(res.data))
						notification.success({
							message: 'Hệ thống',
							description: 'Đăng nhập thành công',
						})
						setMessageTFA(res.data?.message || '')
						setTFAMethod(res.data?.tfaMethod || '')
						setLoading(false);
						setTimeout(() => {
							//Đổi mật khẩu
							if (res.status === 200 && res.data?.isRequiredChangePassword) {
								if (typeof window !== 'undefined' && !(window).__pwdModalOpen) {
									(window).__pwdModalOpen = true;
									Modal.warning({
										icon: null,
										title: 'Thay đổi mật khẩu',
										okText: 'Đóng',
										maskClosable: false,
										closable: false,
										content:
											<div style={{ maxWidth: 420, width: '100%' }}><PasswordForm /></div>,
										onOk: () => {
											(window).__pwdModalOpen = false;
										},
										afterClose: () => {
											(window).__pwdModalOpen = false;
										},
										okButtonProps: { style: { display: 'none' } },
										cancelButtonProps: { style: { display: 'none' } },
									});
								}
								//router.push('/khach-hang/dashboard')
							} else {
								if (res.status === 200 && res.data?.isRequiredOtp === true) {
									setToken(res.data?.otpToken)
									setIsOpenOTP(true);
								} else {
									if (router.asPath.includes("change-password")) {
										router.push('/khach-hang/doi-mat-khau')
									} else {
										router.push('/khach-hang/tao-don-hang')
									}
								}
							}
						}, 1000)

					}


				})
				.catch((err) => {
					recaptchaRef.current?.reset?.()
					setTokenRecaptcha('')
					console.log(err)
				})
		})
	}
	const onActiveAccount = (values) => {
		if (typeof window !== 'undefined' && !window.location.hostname.includes('localhost')) {
			if (!tokenRecaptchaActive) {
				recaptchaActiveRef.current?.reset?.()
				setTokenRecaptchaActive('')
				notification.error({
					message: 'Hệ thống',
					description: 'Vui lòng xác thực mã captcha',
				})
				return
			}
		}

		const params = {
			CustomerID: userName,
			TaxCode: values.TaxCode,
			ContactEmail: values.ContactEmail,
		}
		axios
			.post(api.PMS_ENDPOINT + api.default.API_ACTIVE_ACCOUNT, params, {
				headers: {
					'Content-Type': 'application/json',
					TokenRecaptcha: tokenRecaptchaActive,
				},
			})
			.then((res) => {
				if (res.data.isError) {
					recaptchaActiveRef.current?.reset?.()
					setTokenRecaptchaActive('')
					setSrcImg('/images/wait_noti.png')
				}
				setMessage(res.data.errorMessage)
				setIsOpen(true)
				setTimeout(() => {
					setIsOpen(false)
					setIsLogin(true)
				}, 2500)
			})
			.catch((err) => {
				recaptchaActiveRef.current?.reset?.()
				setTokenRecaptchaActive('')
				console.log(err)
			})
	}

	useEffect(() => {
		if (localStorage.getItem('user')) {
			if (router.asPath.includes("change-password")) {
				router.push('/khach-hang/doi-mat-khau')
			} else {
				router.push('/khach-hang/dashboard')
			}
		}
	}, [])
	useEffect(() => {
		formActive.resetFields()
		recaptchaActiveRef.current?.reset?.()
		setTokenRecaptchaActive('')
	}, [isLogin])

	return (
		<React.Fragment>
			<SEO
				data={{
					title: `Đăng nhập | ${BASE_CONFIG.SLOGAN}`,
					description: 'Đăng ký tài khoản 247Express dễ dàng và nhanh chóng! Trải nghiệm dịch vụ giao hàng chuyên nghiệp, theo dõi đơn hàng tiện lợi, cùng nhiều ưu đãi hấp dẫn',
					keywords: 'Đăng nhập, khám phá',
					url: BASE_CONFIG.PAGE_URL + useRouter().asPath,
				}}
			/>
			<div className="login__page">
				<Row>
					<Col xl={13} lg={13} md={24} sm={24} xs={24}>
						<div className="login__page-left">
							<div className="left-container">
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img src="/images/login.jpg" alt="login" />
							</div>
						</div>
					</Col>
					<Col xl={11} lg={11} md={24} sm={24} xs={24}>
						<div style={{ display: isLogin ? 'inherit' : 'none' }} className="login__page-right">
							<div className="right-header">
								<h1>Đăng nhập</h1>
								<span>Bạn chưa có tài khoản?</span>
								<Link href="/dang-ky">
									Tư vấn báo giá
								</Link>
							</div>
							<div className="right-form">
								{showAlert && (
									<div className="form-error">
										<Alert style={{ color: '#CC0000' }} message={messageError} type="error" />
									</div>
								)}
								<Form form={form} layout="vertical">
									<Form.Item
										name="USERNAME"
										colon={false}
										label={
											<span style={{ color: '#181C32' }}>
												Tài khoản <span style={{ color: '#9F3123' }}> *</span>
											</span>
										}
										required={false}
										rules={[
											{
												whitespace: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng nhập tài khoản
													</span>
												),
											},
											{
												required: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng nhập tài khoản
													</span>
												),
											},
											{
												pattern: /^([^@$!%*#?&]+)([a-zA-Z0-9]+)$/,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Tài khoản không hợp lệ
													</span>
												),
											},
										]}
									>
										<Input placeholder="Nhập tên tài khoản" />
									</Form.Item>
									<Form.Item
										name="PASSWORD"
										label={
											<span style={{ color: '#181C32' }}>
												Mật khẩu <span style={{ color: '#9F3123' }}> *</span>
											</span>
										}
										required={false}
										style={{ marginTop: 16 }}
										rules={[
											{
												required: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng nhập mật khẩu
													</span>
												),
											},
											{
												whitespace: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng nhập mật khẩu
													</span>
												),
											},
										]}
									>
										<Input.Password placeholder="Nhập mật khẩu" />
									</Form.Item>
									<Form.Item
										name="saveAccount"
										colon={false}
										valuePropName="checked"
										labelAlign="left"
										style={{
											marginTop: 18,
										}}
									>
										<div className="form-save__acc">
											<Checkbox>Lưu tài khoản</Checkbox>
											<Link href="/quen-mat-khau">
												Quên mật khẩu?
											</Link>
										</div>
										<div className="form-save__active">
											{/* <p onClick={() => setIsLogin(false)}>
												<a>Kích hoạt tài khoản web</a>
											</p> */}
										</div>
									</Form.Item>
									<Form.Item
										//name="Captcha"
										style={{
											marginTop: 18,
										}}
									>
										<ReCAPTCHA
											sitekey={api.SITE_KEY}
											onChange={(token) => setTokenRecaptcha(token)}
											onExpired={(token) => setTokenRecaptcha('')}
											ref={recaptchaRef}
											hl={'vi'}
										/>
									</Form.Item>
									<Form.Item style={{ marginTop: 32 }}>
										<div className="form-submit">
											<Button
												type="primary"
												htmlType="submit"
												loading={loading}
												style={{
													height: 44,
													fontWeight: 500,
													fontSize: 16,
													padding: '0px 32px',
												}}
												onClick={onLogin}
											>
												Đăng nhập
											</Button>
										</div>
									</Form.Item>
								</Form>
							</div>
						</div>

						<div style={{ display: !isLogin ? 'inherit' : 'none' }} className="login__page-right">
							<div className="right-header">
								<h1>Kích hoạt tài khoản web</h1>
								<p>
									Tài khoản <strong style={{ color: '#cc0000' }}>{userName}</strong> chưa được kích
									hoạt sử dụng trên website. Vui lòng nhập các thông tin sau để đăng ký.
								</p>
							</div>
							<div className="right-form">
								<Form form={formActive} layout="vertical" onFinish={onActiveAccount} >
									{/* <Form.Item
										name="CustomerID"
										colon={false}
										label={
											<span style={{ color: '#181C32' }}>
												Mã khách hàng <span style={{ color: '#9F3123' }}> *</span>
											</span>
										}
										required={false}
										rules={[
											{
												whitespace: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng nhập mã khách hàng
													</span>
												),
											},
											{
												required: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng nhập mã khách hàng
													</span>
												),
											},
										]}
									>
										<Input placeholder="Nhập mã khách hàng" />
									</Form.Item> */}
									<Form.Item
										name="TaxCode"
										label={
											<span style={{ color: '#181C32' }}>
												Mã số thuế <span style={{ color: '#9F3123' }}> *</span>
											</span>
										}
										required={false}
										style={{ marginTop: 16 }}
										rules={[
											{
												required: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng mã số thuế
													</span>
												),
											},
											{
												whitespace: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng mã số thuế
													</span>
												),
											},
										]}
									>
										<Input placeholder="Nhập mã số thuế" />
									</Form.Item>
									<Form.Item
										name="ContactEmail"
										label={
											<span style={{ color: '#181C32' }}>
												Email người liên hệ <span style={{ color: '#9F3123' }}> *</span>
											</span>
										}
										required={false}
										style={{ marginTop: 16 }}
										rules={[
											{
												required: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng email người liên hệ
													</span>
												),
											},
											{
												whitespace: true,
												message: (
													<span style={{ color: '#CC0000', fontSize: 12 }}>
														Vui lòng email người liên hệ
													</span>
												),
											},
										]}
									>
										<Input placeholder="Nhập email người liên hệ" />
									</Form.Item>
									<Form.Item style={{ marginTop: 18 }}>
										<ReCAPTCHA
											sitekey={api.SITE_KEY}
											onChange={(token) => setTokenRecaptchaActive(token)}
											onExpired={() => setTokenRecaptchaActive('')}
											ref={recaptchaActiveRef}
											hl={'vi'}
										/>
									</Form.Item>
									<Form.Item style={{ marginTop: 32 }}>
										<div className="form-submit">
											<Button
												type="primary"
												htmlType="submit"
												loading={loading}
												style={{
													height: 44,
													fontWeight: 500,
													fontSize: 16,
													padding: '0px 32px',
												}}
											// onClick={onActiveAccount}
											>
												Kích hoạt
											</Button>
										</div>
									</Form.Item>
								</Form>
							</div>
							<NotifyPopup
								title={'Thông báo'}
								message={message}
								setIsVisiblePopup={setIsOpen}
								isVisible={isOpen}
								srcImage={srcImg}
								closable={true}
							></NotifyPopup>
						</div>
					</Col>
				</Row>
				<VerifyLoginModal onClose={() => { setIsOpenOTP(false) }} open={isOpenOTP} key={""} token={token} message={messageTFA} tFAMethod={tFAMethod} />
			</div>
		</React.Fragment>
	)
}

Login.Layout = SignLayout
export default Login
